import React, { Component } from 'react';
import { getSquircleThumbnailUrl } from '../../utils/imageUtils';

export default class ProfileImage extends Component {
  static defaultProps = {
    sizeType: 'small'
  };

  render() {
    const { image, sizeType } = this.props; 
    const imageUrl = image[`${sizeType}Url`];

    const isVertical = image.height > image.width;

    return (
      <img src={getSquircleThumbnailUrl(imageUrl)} className="img_thumb"
        style={{
          width: isVertical ? '100%' : 'auto', 
          height: isVertical ? 'auto' : '100%',
          position: 'absolute',
          left: '-100%',
          right: '-100%',
          top: '-100%',
          bottom: '-100%',
          margin: 'auto',
          minHeight: '100%',
          minWidth: '100%'
        }}
      />
    )
  }
};



// WEBPACK FOOTER //
// ./src/components/ProfileImage/index.js